import { useMemo } from "react";
import { useGetList } from "react-admin";
import type { AuditRecord } from "@/types";

/**
 * Fetches audit log entries for a specific endorsement from the
 * `GET /audit?object_id={endorsementId}` endpoint.
 *
 * Returns the records sorted newest-first so the Event History
 * timeline reads top → bottom as most-recent → oldest.
 */
export const useEndorsementAuditLog = (endorsementId: string) => {
  const {
    data: rawRecords = [],
    isLoading,
    refetch,
  } = useGetList<AuditRecord>(
    "audit",
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "created_datetime", order: "DESC" },
      filter: { object_id: endorsementId },
    },
    { enabled: !!endorsementId }
  );

  // Ensure newest-first (API may not honour sort for audit)
  const records = useMemo(
    () =>
      [...rawRecords].sort((a, b) => new Date(b.created_datetime).getTime() - new Date(a.created_datetime).getTime()),
    [rawRecords]
  );

  return { records, isLoading, refetch };
};
